import { ApplicationInquiryMain } from "../components/application-inquiry/Main";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";

/**
 * 申請内容照会
 */
const ApplicationInquiry = () => {
  useAuthenticationHook(PERMISSIONS.PROGRESS);

  return <ApplicationInquiryMain />;
};

export default ApplicationInquiry;
